import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, " Check your notifications on another device ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " Go to your Facebook account on another device and open the notification we sent to approve this login. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-bold" }, "Waiting for approval", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "It may take a few minutes to get the notification on your other device.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_q_linear_progress, {
      indeterminate: "",
      class: "q-my-md"
    }),
    _hoisted_3,
    _hoisted_4
  ]))
}